export default __webpack_public_path__ + "static/media/mao-coracao.38a6d539.png";